import Box from 'components/shared/Box'
import { Wrapper } from './styles'
import RadioInput from 'components/shared/Radio/input'
import Text from 'components/shared/Text'
import { ReactNode } from 'react'
import { VoucherType } from 'store/api-slice/types'

interface VoucherTypeRadioProps {
    option: VoucherType
    id: string
    icon: string
    label: string
    teaser: ReactNode
    isChecked: boolean
    testId?: string
    onClick: (option: VoucherType) => void
}

const VoucherTypeRadio = ({
    option,
    id,
    icon,
    label,
    teaser,
    isChecked,
    testId,
    onClick,
}: VoucherTypeRadioProps) => (
    <Wrapper
        align="center"
        justify="space-between"
        gap={[12, 16]}
        isChecked={isChecked}
        data-testid={testId}
        onClick={() => onClick(option)}
    >
        <img src={icon} alt="" />
        <Box align="center" justify="center" gap={[4, 8]}>
            <Text variant="heading4" color="primary_500" align="center">
                {label}
            </Text>
            <Text variant="bodySmall" color="grayscale_700" align="center">
                {teaser}
            </Text>
        </Box>
        <RadioInput option={option} id={id} isChecked={isChecked} />
    </Wrapper>
)

export default VoucherTypeRadio
